import Vue from "vue";

const prodURL =
    window.location.origin.includes("indsiders.com") &&
    !window.location.origin.includes("dev") &&
    !window.location.origin.includes("homolog");
const homologURL = window.location.origin.includes("homolog");
const hostname = window.location.hostname;
const localNetworkURL =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^10\./.test(hostname) ||
    /^192\.168\./.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(hostname);
const myIndOverride = process.env.VUE_APP_MYIND_URL;

if (myIndOverride) {
    Vue.prototype.$myIndLink = myIndOverride.endsWith("/")
        ? myIndOverride
        : `${myIndOverride}/`;
    Vue.prototype.$mySfcLink = window.location.origin + "/";
} else if (prodURL) {
    Vue.prototype.$mySfcLink = "https://mysfc-v2.indsiders.com/";
    Vue.prototype.$myIndLink = "https://myind-v2.indsiders.com/";
} else if (homologURL) {
    Vue.prototype.$mySfcLink = "https://mysfc-homolog.indsiders.com/";
    Vue.prototype.$myIndLink = "https://myind-homolog.indsiders.com/";
} else if (localNetworkURL) {
    const localOrigin = `${window.location.protocol}//${hostname}`;
    Vue.prototype.$mySfcLink = `${localOrigin}:8081/`;
    Vue.prototype.$myIndLink = `${localOrigin}:8080/`;
} else {
    Vue.prototype.$mySfcLink = "https://mysfc-dev.indsiders.com/";
    Vue.prototype.$myIndLink = "https://myind-dev.indsiders.com/";
}
